import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	switchInput: {
		width: '100%',
		paddingBottom: '1rem'
	},
	switchInputTypography: {
		fontWeight: '600',
		color: theme.palette.primary.grey,
		width: '100%',
		padding: '0',
		textAlign: 'left'
	}
}));
